import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout'
import { Home } from './pages/home'
import { Wizard } from './pages/wizard'
import { Result } from './pages/result'
import { Deploy } from './pages/deploy'
import { Channels } from './pages/channels'
import { Skills } from './pages/skills'
import { SecFix } from './pages/sec-fix'
import { Community } from './pages/community'
import { Enterprise } from './pages/enterprise'
import { ScenarioGuide } from './pages/scenario-guide'

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wizard" element={<Wizard />} />
        <Route path="/wizard/result" element={<Result />} />
        <Route path="/deploy" element={<Deploy />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/sec-fix" element={<SecFix />} />
        <Route path="/community" element={<Community />} />
        <Route path="/enterprise" element={<Enterprise />} />
        <Route path="/guides/:slug" element={<ScenarioGuide />} />
      </Routes>
    </Layout>
  )
}
